/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import {
  Popup
} from 'semantic-ui-react';
import withScrollbar from '../Extensions/WithScrollbar';
import api from '../../api';
import RenderProjectTree from '../Extensions/RenderProjectTree';
import ScannedFilesInfoModal from '../Modal/ScannedFilesInfoModal';

class LicenseRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMSF: false,
      popupStatus: {
        treePopup: false,
      },
      activeTreeIndex: '',
      securityTreeData: [],
      scannedFileIds: [],
    };
    this.handleComponentFileModal = this.handleComponentFileModal.bind(this);
    this.handleTreeOpen = this.handleTreeOpen.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  handleTreeOpen(value, ids) {
    //const { t } = this.props;
    const obj = JSON.parse(`[${ids}]`);
    const objData = { uploaded_file_ids: obj };
    const popupStatus = {
      treePopup: true,
    };

    api
      .getProjectTree(objData)
      .then((response) => {
        const data = response.response;
        this.setState({
          securityTreeData: data,
          popupStatus,
          activeTreeIndex: value,
        });
      })
      .catch((err) => {
        console.log(err);
        /*
        this.setState({
          error: t('modal.error.error_load'),
        });
      */
      });
  }

  handleComponentFileModal = (ids) => {
    this.setState({
      scannedFileIds: ids,
      isOpenMSF: true,
    });
  };

  closePopup() {
    const popupStatus = {
      treePopup: false,
    };

    this.setState({
      popupStatus,
      activeTreeIndex: '',
    });
  }

  closeModal() {
    this.setState({
      scannedFileIds: [],
      isOpenMSF: false,
    });
  }

  renderTreeTable(obj) {
    let totalCount = 0;
    for (let i = 0; i < Object.keys(obj).length; i++) {
      const arr = obj[Object.keys(obj)[i]];
      for (let j = 0; j < arr.length; j++) {
        totalCount++;
      }
    }

    return (
      Object.keys(obj).map((groupDetail, k) => {
        return (
          obj[groupDetail].map((file, l) => {
            return (
              <tr
                className=""
                key={`${file.component_name}_${file.component_version}_${file.scanned_file_name}`}
              >
                {
                  k === 0 && l === 0 ? (
                    <td className="tac border-bottom" rowSpan={totalCount}>
                      {file.component_name}
                    </td>
                  ) : null
                }
                {
                  l === 0 ? (
                    <td className="tac border-bottom" rowSpan={obj[groupDetail].length}>
                      {file.component_version}
                    </td>
                  ) : null
                }
                <td className="tac border-bottom has_link">
                  <span
                    onClick={() => {
                      return this.handleComponentFileModal(file.scanned_file_ids);
                    }}
                    onKeyUp={() => {
                      return this.handleComponentFileModal(file.scanned_file_ids);
                    }}
                  >
                    {file.scanned_file_name}
                  </span>
                </td>
              </tr>
            );
          })
        );
      })
    );
  }

  render() {
    const {
      rowData,
      t,
      state,
      location,
      params,
      uid,
    } = this.props;

    const {
      popupStatus,
      activeTreeIndex,
      securityTreeData,
      scannedFileIds,
      isOpenMSF,
    } = this.state;

    const pathname = location.pathname ? location.pathname : location;

    if (pathname.indexOf(params.idReport) > -1) {
      return (
        <div>
          {
            Object.keys(rowData.licenses).map((groupName) => {
              return (
                <table
                  className="wide_card_table wide_card_item"
                  key={groupName.toString()}
                >
                  <colgroup>
                    <col style={{ width: '33%' }} />
                    <col style={{ width: '33%' }} />
                    <col style={{ width: '33%' }} />
                  </colgroup>
                  <tbody>
                    {this.renderTreeTable(rowData.licenses[groupName])}
                  </tbody>
                </table>
              );
            })
          }
          <ScannedFilesInfoModal
            isOpenMSF={isOpenMSF}
            closeModal={this.closeModal}
            ufid={uid}
            scannedFileIds={scannedFileIds}
            translate={t}
          />
        </div>
      );
    }
    return Object.keys(rowData.licenses).map((groupName) => {
      return (
        <table
          className="wide_card_table wide_card_item"
          key={groupName.toString()}
        >
          <colgroup>
            <col style={{ width: '12.9%' }} />
            <col style={{ width: '12.9%' }} />
            <col style={{ width: '55.5%' }} />
            <col style={{ width: '18.6%' }} />
          </colgroup>
          <tbody>
            {rowData.licenses[groupName].map(
              (array, k) => {
                return (
                  <tr
                    key={`${array.component_name}_${array.component_version}`}
                  >
                    {
                      k === 0 ? (
                        <td
                          className="border-none tac border-bottom"
                          style={{
                            paddingLeft: '7px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                          rowSpan={rowData.licenses[groupName].length}
                        >
                          {array.component_name}
                        </td>
                      ) : null
                    }
                    <td
                      className="tac border-bottom"
                      style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {array.component_version}
                    </td>
                    <td className="sum_td border-bottom">
                      <Popup
                        trigger={(
                          <div
                            className="hover_area"
                          >
                            <table className="sub_table">
                              <colgroup>
                                <col
                                  style={{
                                    width: '33%',
                                  }}
                                />
                                <col
                                  style={{
                                    width: '33%',
                                  }}
                                />
                                <col
                                  style={{
                                    width: '33%',
                                  }}
                                />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">
                                    {array.project_count}
                                  </td>
                                  <td className="tac">
                                    {array.project_version_count}
                                  </td>
                                  <td className="tac">
                                    {array.uploaded_file_count}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        on="click"
                        position="bottom left"
                        open={
                          popupStatus.treePopup && activeTreeIndex === `${array.component_name}_${array.component_version}`
                        }
                        onOpen={() => {
                          return this.handleTreeOpen(`${array.component_name}_${array.component_version}`, array.uploaded_file_ids);
                        }}
                        onClose={this.closePopup}
                        hideOnScroll
                        wide="very"
                      >
                        <RenderProjectTree
                          treeData={securityTreeData}
                          translate={t}
                          tableType
                          state={state}
                        />
                      </Popup>
                    </td>
                    <td className="tac border-bottom">
                      {array.last_detected}
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      );
    });
  }
}

export default withScrollbar(LicenseRow);
